// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Loader__Loader__34pxb","fade":"Loader__fade__292GC","ContentHolder":"Loader__ContentHolder__se5Uf","UfcIcon":"Loader__UfcIcon__bi_X7","pulse":"Loader__pulse__3Z9dw","Message":"Loader__Message__3KzY3","Animate":"Loader__Animate__2oRVg","shrink":"Loader__shrink__zjtUj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/Loader.css
// module id = 349
// module chunks = 0